import React from 'react';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
//------------------------------------------------------------------
import './style.scss';
import useMenuRedirect from '../../../../../Menu/hooks/useMenuRedirect';
import { PUSHTOHISTORY } from 'constants.js';
import { eventIsAllow, isChannelBlocked } from 'containers/EPG/utils';
import { useSelector } from 'react-redux';
import { useGetAdultRating } from 'containers/Player/hooks/useGetAdultRating';

import ChannelCardHeader from './components/ChannelCardHeader';
import ChannelCardTimeBox from './components/ChannelCardTimeBox';
import ChannelCardPoster from './components/ChannelCardPoster';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

export const ChannelCard = ({
  contentInfo,
  carouselTitle,
  contentPosition,
}) => {
  const { navigateToChannel, nodesSelected } = useMenuRedirect();

  const blockedChannels = useSelector(
    state => state.cvEpg.channelBlocker?.statusControlPin?.data?.pin_channel?.info,
  );
  const channelBlocked = isChannelBlocked(
    contentInfo?.group_id,
    blockedChannels,
  );

  const { isAdultRateEvent } = useGetAdultRating();
  const adultRated = isAdultRateEvent(contentInfo?.event?.parental_rating);

  const shouldNotShowEvent = channelBlocked || adultRated;

  const date_begin = contentInfo?.event?.date_begin;
  const date_end = contentInfo?.event?.date_end;

  const eventType = eventIsAllow({
    date_begin,
    date_end,
  });

  const isAvailableToPlay = eventType === 'play';

  const handleCardClick = e => {
    e.stopPropagation();

    if (!isAvailableToPlay) return;
    // gtm event
    pushSelectContentEvent(
      contentInfo,
      nodesSelected,
      carouselTitle,
      contentPosition,
    );
    // navegar al canal
    navigateToChannel(
      { ...contentInfo, id: contentInfo?.group_id },
      PUSHTOHISTORY,
    );
  };

  return (
    <div
      className={`channel-card ${!isAvailableToPlay && 'no-pointer'}`}
      onClick={handleCardClick}
    >
      <ChannelCardHeader
        contentInfo={contentInfo}
        shouldNotShowEvent={shouldNotShowEvent}
      />

      <div className="channel-card__footer">
        <p className="channel-card__event-name">{renderMaxLengthText(contentInfo?.event?.name, 30)}</p>
        <ChannelCardTimeBox contentInfo={contentInfo} />
      </div>

      <ChannelCardPoster
        contentInfo={contentInfo}
        shouldNotShowEvent={shouldNotShowEvent}
      />
    </div>
  );
};
